'use strict';

/* eslint no-undef: "off" */
/**
 * base slider
 */
define('baseSlider',['swiper', 'busEvent'], function (Swiper, busEvent) {
  return {
    template: '\n      <div class="in-swiper swiper-container" ref="swiperContainer">\n        <div class="swiper-wrapper">\n            <slot></slot>\n        </div>\n        <div @click.prevent="(e) => preventClick(e)" class="swiper-pagination" v-if="sliderConfig.isPagination"></div>\n        <div @click.prevent="(e) => preventClick(e)" class="swiper-button-prev" v-if="sliderConfig.isButtonPrev"></div>\n        <div @click.prevent="(e) => preventClick(e)" class="swiper-button-next" v-if="sliderConfig.isButtonNext"></div>\n      </div>\n    ',
    props: {
      sliderConfig: {
        type: Object,
        default: {
          isPagination: false,
          isButtonPrev: false,
          isButtonNext: false,
          isScrollbar: false,
          coreSliderConfig: {}
        },
        required: true
      }
    },
    data: function data() {
      return {
        slider: {}
      };
    },
    mounted: function mounted() {
      var _this = this;

      setTimeout(function () {
        _this.initSlider();
      }, 20);
    },

    methods: {
      initSlider: function initSlider() {
        /* eslint-disable no-new */
        this.slider = new Swiper(this.$refs.swiperContainer, this.sliderConfig.coreSliderConfig);
        this.scrollEvent();
        this.slideEvent();
        this.slideSwiperEvent();
        return this.updateEvent();
      },
      preventClick: function preventClick(e) {
        e.preventDefault();
        e.stopPropagation();
      },
      updateSlider: function updateSlider() {
        this.slider.update();
      },
      updateEvent: function updateEvent() {
        var _this2 = this;

        busEvent.$on('updateSliderEvent', function () {
          _this2.updateSlider();
        });
      },
      scrollSlider: function scrollSlider() {
        this.slider.slideTo(0);
      },
      scrollEvent: function scrollEvent() {
        var _this3 = this;

        busEvent.$on('scrollSliderEvent', function () {
          _this3.scrollSlider();
        });
      },
      slideSlider: function slideSlider(index) {
        this.slider.slideTo(index);
      },
      slideEvent: function slideEvent() {
        var _this4 = this;

        busEvent.$on('slideSliderEvent', function (index) {
          _this4.slideSlider(index);
        });
      },
      slideSwiper: function slideSwiper(index) {
        var elClass = this.slider.$el[0].getAttribute('class');
        if (elClass.indexOf('in-flash-date-slider') >= 0) {
          this.slider.slideTo(index);
        }
      },
      slideSwiperEvent: function slideSwiperEvent() {
        var _this5 = this;

        busEvent.$on('slideSwiperEvent', function (index) {
          _this5.slideSwiper(index);
        });
      }
    }
  };
});
